import { frontendURL } from '../../../helper/URLHelper';
import TestInboxIndex from './pages/TestInboxIndex.vue';

// Admin-only: customer impersonation sandbox. Also gated on the `test_inbox`
// module being licensed for the account (see license-test-inbox-module).
const commonMeta = {
  permissions: ['administrator'],
  dotchatModule: 'test_inbox',
};

export const routes = [
  {
    path: frontendURL('accounts/:accountId/test-inbox'),
    component: TestInboxIndex,
    meta: commonMeta,
    children: [
      {
        path: '',
        name: 'test_inbox_index',
        component: TestInboxIndex,
        meta: commonMeta,
      },
    ],
  },
];
